import { render } from "./NewRequestView.vue?vue&type=template&id=cdddcaa6"
import script from "./NewRequestView.vue?vue&type=script&lang=js"
export * from "./NewRequestView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__